import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CgMenuLeft } from "react-icons/cg";
function Header() {
  const { user } = useSelector(state => state);
  const dispatch = useDispatch();
  return (
    <nav className="navbar">
      <div className="container-fluid">
        <div className="header-logo">
          <Link to="/">
            <img
              src={window.location.origin + "/img/logo/logo2.png"}
              alt="..."
            />
            <span
              className="logo-text d-none d-lg-block"
              style={{ fontWeight: "600", color: "#fff" }}
            >
              نیکوتن
            </span>
          </Link>
        </div>
        <div className="header-body" style={{ justifyContent: "flex-end" }}>
          <ul className="navbar-nav">
            <li className="nav-item dropdown">
              <Link
                to="#"
                id="dropdownMenuLink"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                className="d-flex align-items-center"
              >
                <h6
                  className="m-0"
                  style={{
                    color: "#fff",
                    fontSize: "0.8125rem",
                    fontWeight: 400,
                    paddingLeft: "10px",
                  }}
                >
                  {user.fullname}
                </h6>
                <figure className="avatar avatar-sm avatar-state-Success">
                  <img
                    style={{ borderRadius: "50%" }}
                    src={
                      user.profile && user.profile.length > 0
                        ? user.profile[0]
                        : window.location.origin + "/img/user.png"
                    }
                    alt="..."
                  />
                </figure>
              </Link>
              <div className="dropdown-menu dropdown-menu-right">
                <Link to="/User/Dashboard" className="dropdown-item">
                  <i className="icon ti-dashboard" /> <span>داشبورد</span>{" "}
                </Link>
                <Link to="/User/setting" className="dropdown-item">
                  <i className="icon ti-id-badge" /> <span>پروفایل</span>{" "}
                </Link>
                <div className="dropdown-divider" />
                <a
                  style={{ cursor: "pointer" }}
                  className="text-danger dropdown-item"
                  onClick={() => {
                    window.location.replace("/");
                    dispatch({
                      type: "CLEAR",
                    });
                  }}
                >
                  <i className="icon ti-face-sad" /> <span>خروج از حساب</span>{" "}
                </a>
              </div>
            </li>
            <li className="nav-item d-lg-none d-sm-block">
              <Link to="#" className="nav-link side-menu-open">
                <CgMenuLeft size={26} />
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Header;
